import { render, staticRenderFns } from "./add_case_dialog.vue?vue&type=template&id=6125220b&scoped=true"
import script from "./add_case_dialog.vue?vue&type=script&lang=js"
export * from "./add_case_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_case_dialog.vue?vue&type=style&index=0&id=6125220b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125220b",
  null
  
)

export default component.exports